<template>
    <div>
        <myHeader></myHeader>
        <aboutNav></aboutNav>
        <div class="team_wrap">
            <div class="team">
                <el-image v-for="url in url_img" :key="url" :src="url" :preview-src-list="url_img" fit="fill" class="team_img"></el-image>
                <el-empty :image-size="160" v-show="url_img.length === 0"></el-empty>
            </div>
        </div>
        <myFooter></myFooter>
    </div>
</template>

<script>
import myHeader from '../../components/header.vue'
import MyFooter from '../../components/footer.vue'
import aboutNav from '../../components/about_nav.vue'
export default {
    name: 'about_team',
    components: {MyFooter, myHeader,aboutNav},
    data () {
        return {
            url_img: []
        }
    },
    created () {
        this.pageData();
    },
    methods: {
        pageData () {
            this.$api.teamImageList().then(res => {
                let urlList = res.data;
                this.url_img = urlList.map((item) => {
                    return item.image
                })
            });
        },
    }
}
</script>

<style scoped>
.team_wrap{width:100%;height:auto;min-height:200px;float:left;padding:50px 0 60px;}
.team{width:1200px;height:auto;min-height:200px;position:relative;left:50%;margin-left:-600px;float:left;margin-top:0;}
.team .team_img{width:390px;height:290px;display:inline-block;float:left;margin-left:15px;margin-top:15px;overflow:hidden;cursor:pointer;}
.team .team_img:nth-child(3n-2){margin-left:0;}
.team .team_img:nth-child(1){margin-top:0;}
.team .team_img:nth-child(2){margin-top:0;}
.team .team_img:nth-child(3){margin-top:0;}
.team .team_img img{width:100%;height:auto;display:block;}
@media (min-width:992px) and (max-width:1200px){
    .team_wrap{min-height:200px;padding:40px 0 50px;}
    .team{width:1000px;min-height:200px;margin-left:-500px;}
    .team .team_img{width:324px;height:220px;margin-left:14px;margin-top:14px;}
    .team .team_img:nth-child(3n-2){margin-left:0;}
    .team .team_img:nth-child(1){margin-top:0;}
    .team .team_img:nth-child(2){margin-top:0;}
    .team .team_img:nth-child(3){margin-top:0;}
}
@media (min-width:768px) and (max-width:991px){
    .team_wrap{min-height:200px;padding:30px 0 40px;}
    .team{width:750px;min-height:200px;margin-left:-375px;}
    .team .team_img{width:242px;height:160px;margin-left:12px;margin-top:12px;}
    .team .team_img:nth-child(3n-2){margin-left:0;}
    .team .team_img:nth-child(1){margin-top:0;}
    .team .team_img:nth-child(2){margin-top:0;}
    .team .team_img:nth-child(3){margin-top:0;}
}
@media (max-width:767px){
    .team_wrap{min-height:200px;padding:20px 15px 30px;}
    .team{width:100%;min-height:200px;margin-left:0;left:0;}
    .team .team_img{width:100%;height:auto;margin-left:0;margin-top:10px;}
    .team .team_img:nth-child(3n-2){margin-left:0;}
    .team .team_img:nth-child(1){margin-top:0;}
    .team .team_img:nth-child(2){margin-top:10px;}
    .team .team_img:nth-child(3){margin-top:10px;}
}
</style>



// WEBPACK FOOTER //
// src/pages/about/about_team.vue